import script from "./UserListView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserListView.vue?vue&type=script&setup=true&lang=js"

import "./UserListView.vue?vue&type=style&index=0&id=7a8bc120&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a8bc120"]])

export default __exports__